import React from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { LoyaltyBenefits } from '@thd-olt-component-react/loyalty-benefits';

export function CustomRenderedLoyaltyBenefits() {
  return (
    <QueryProvider cacheKey="loyalty-benefits-cacheKey">
      <LoyaltyBenefits />
    </QueryProvider>
  );
}
